/* eslint-ignore */
// @ts-nocheck
import React from 'react';

import {
  Container,
  TolltipItens,
  TooltipContainer,
  TootipTitle,
} from './styles';

type CustomTooltipProps = {
  title: string;
  className: string;
  componentShow: React.ReactNode;
  children: React.ReactNode;
};

const CustomToolip: React.FC<CustomTooltipProps> = ({
  title,
  className,
  componentShow: Component,
  children,
}) => {
  return (
    <Container className={className}>
      {children}
      <TooltipContainer>
        {title && <TootipTitle>{title}</TootipTitle>}
        <TolltipItens>
          <Component />
        </TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default CustomToolip;
